// A ‘.tsx’ file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React, { createRef } from 'react';
import ReactDOM from 'react-dom';
interface DropDownListProps {
    displayProp?: string;
    valueProp?: string;
    datasource: any[];
    onChange: any;
    initialValue?: string;
    enabled?: boolean;
    autoWidth?: boolean;
    width?: string;
}

class DropDownList extends React.Component<DropDownListProps, any> {
    _inputRef = createRef<HTMLInputElement>();
    constructor(props: DropDownListProps) {
        super(props);

    }

    private _setOptions = (props: DropDownListProps) => {
        var options: any = {
            dataSource: props.datasource,
            change: this._onChange
        };

        if (props.displayProp) {
            options.dataTextField = props.displayProp;
        }
        if (props.valueProp) {
            options.dataValueField = props.displayProp;
        }

        if (props.enabled !== undefined && props.enabled !== null) {
            options.enable = props.enabled;
        }

        if (props.autoWidth) {
            options.autoWidth = props.autoWidth;
        }

        var jDropDownControl = ($(this._inputRef.current) as any).kendoDropDownList(options);

        // This fixes an issue (bug in Kendo DropDown control?), where a scroll bar
        // is not automatically added if the number of items in the list exceeds
        // the control's height, causing the items to "overflow" the boundaries
        // of the control.
        var kendoDropdown = jDropDownControl.data('kendoDropDownList');
        kendoDropdown.ul.css("max-height", kendoDropdown.options.height + "px");
    }

    private _setInitialValue = (props: DropDownListProps) => {
        if (props.initialValue) {
            var kendoDropdown = $(this._inputRef.current).data('kendoDropDownList');
            kendoDropdown.select((obj: any) => {
                if (props.valueProp) {
                    return props.initialValue === obj.toJSON()[props.valueProp];
                } else {
                    return props.initialValue === obj;
                }
            })
        }
    }

    private _onChange = (e: any) => {
        this.props.onChange(e.sender.dataItem());
    }

    UNSAFE_componentWillReceiveProps(nextProps: DropDownListProps) {
        if (JSON.stringify(nextProps) !== JSON.stringify(this.props)) {
            this._setOptions(nextProps);
            this._setInitialValue(nextProps);
        }
    }

    componentDidMount() {
        this._setOptions(this.props);
        this._setInitialValue(this.props);

    }

    componentWillUnmount() {
        var kendoDropdown = $(ReactDOM.findDOMNode(this)).data('kendoDropDownList');
        if (kendoDropdown) {
            kendoDropdown.destroy();
        }
    }

    render() {
        return <input ref={this._inputRef} style={{ width: this.props.width }} />;
    }

}

export default DropDownList;